import React from 'react';
import { ArrowLeft, Download, Upload, Trash2, Pencil, ShieldAlert } from 'lucide-react';
import { Button } from '../../components/ui/button';

const DocumentHeader = ({ doc, client, statusCfg, isExcluded, isAdmin, canEdit, exporting, onBack, onExport, onDelete, onUpload, onEditVars, editMode }) => {
  return (
    <>
      {isExcluded && (
        <div className="bg-red-50 border border-red-200 rounded-xl p-4 flex items-center gap-3" data-testid="excluded-warning">
          <ShieldAlert className="w-5 h-5 text-red-600 flex-shrink-0" />
          <div>
            <p className="font-semibold text-red-700">Documento Excluido</p>
            <p className="text-sm text-red-600">{isAdmin ? 'Este documento foi excluido. Apenas administradores podem visualiza-lo.' : 'Acesso restrito.'}</p>
          </div>
        </div>
      )}

      <div className="flex items-start justify-between">
        <div className="flex items-start gap-4">
          <Button variant="outline" size="sm" onClick={onBack} data-testid="back-button">
            <ArrowLeft className="w-4 h-4" />
          </Button>
          <div>
            <h1 className="text-2xl font-bold text-[#111111]">{doc.title}</h1>
            <div className="flex items-center gap-3 mt-1 text-sm text-[#6E6E73]">
              <span>{doc.tipo}</span>
              <span>-</span>
              <span>{client?.razao_social || 'N/A'}</span>
              <span>-</span>
              <span>v{doc.current_version}</span>
            </div>
          </div>
        </div>
        <span className={`${statusCfg.color} text-white px-3 py-1.5 rounded-full text-sm font-medium flex items-center gap-1.5`} data-testid="document-status">
          <statusCfg.icon className="w-3.5 h-3.5" />
          {statusCfg.label}
        </span>
      </div>
    </>
  );
};

export default DocumentHeader;
